module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/apercu-italic-pro-0d22bc3aaed145bc0add5fa02611334e.ttf";